import { Link } from '@chakra-ui/react';

import { SharedRichTextProps } from './shared-rich-text-props.type';

export const RichTextLink = ({ children }: SharedRichTextProps) => (
  <Link color="brand.chelseaGem">{children}</Link>
);
